<template>
  <div>
    <div
      class="l-captcha"
      data-site-key="dfa24eee8d556648f5051751d7c10c91"
      data-width="100%"
      data-callback="getResponse"
    ></div>
    <div class="chongzhi" @click="chongzhi">重新验证</div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    methods: {
      dynamicLoadJs: function(url, callback) {
        var head = document.getElementsByTagName("head")[0];
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        if (typeof callback == "function") {
          script.onload = script.onreadystatechange = function() {
            if (
              !this.readyState ||
              this.readyState === "loaded" ||
              this.readyState === "complete"
            ) {
              callback();
              script.onload = script.onreadystatechange = null;
            }
          };
        }
        head.appendChild(script);
      },
      chongzhi(){
        LUOCAPTCHA.reset();
      },

    },
    created() {
      const self = this;
      this.dynamicLoadJs("//captcha.luosimao.com/static/dist/api.js");
      window.getResponse = (resp) => {
        var els =document.getElementsByName("luotest_response");
        if (els.length === 1 && els[0].value === resp) {

          self.$emit("success", resp);
        } else {
          // eslint-disable-next-line
          LUOCAPTCHA && LUOCAPTCHA.reset();
        }
      }
    },
  };
</script>
<style scoped>
  .chongzhi{
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    color: #333333;
    background: #D81023;
    color: #ffffff;
    border-radius: 5px;
    margin: 10px auto;
    cursor: pointer;

  }
</style>
